import { NgIf, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

import { SitecoreImageResizePipe } from '@casinocore/platform/core';

import { ParallaxDirective } from './cwdj-parallax.directive';

@Component({
    selector: 'cc-parallax-animation',
    templateUrl: 'parallax-animation.component.html',
    standalone: true,
    imports: [NgIf, NgStyle, ParallaxDirective, SitecoreImageResizePipe],
})
export class ParallaxAnimationComponent {
    @Input() subCategory: any;
}
